<template>
    <div style="padding: 10px">
        <Modal v-model="isShowStateModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#19be6b;text-align:center">
                <Icon type="md-create" />
                <span>修改账号信息</span>
            </p>
            <Form :model="updateObject" label-position="left" :label-width="100">
                <!-- <FormItem label="客户账号">
          <Input v-model="updateObject.userAccount" placeholder="输入客户账号" style="width: 250px" />
        </FormItem> -->
                <FormItem style="margin-top:-20px" label="客户名称">
                    <Input v-model="updateObject.userName" placeholder="输入客户名称" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="客户账号">
                    <Input v-model="updateObject.userAccount" placeholder="输入客户账号" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="客户密码">
                    <Input v-model="updateObject.userPassword" placeholder="输入客户密码" style="width: 250px" />
                </FormItem>
                <!-- <FormItem style="margin-top:-20px"  label="用户身份">
          <Select v-model="updateObject.userAuth" style="width:250px" placeholder="选择用户身份">
            <Option v-if="key != '0'" v-for="(value, key) in userAuthEnum" :value="key" :key="key">{{value}}</Option>
          </Select>
        </FormItem> -->
                <FormItem style="margin-top:-20px" label="设备类型">
                    <Select disabled v-model="updateObject.userMeterType" style="width:250px" placeholder="选择设备类型">
                        <Option v-for="item in showOrder" :value="item" :key="item">{{ userMeterTypeEnum[item] }}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button style="margin-right:38%" type="primary" @click="updateUser">提交更新</Button>
            </div>
        </Modal>
        <Modal v-model="isInserteModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#19be6b;text-align:center">
                <Icon type="md-create" />
                <span>新增账号信息</span>
            </p>
            <Form :model="insertObject" label-position="left" :label-width="100">
                <FormItem label="客户名称">
                    <Input v-model="insertObject.userName" placeholder="输入客户名称" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="客户账号">
                    <Input v-model="insertObject.userAccount" placeholder="输入客户账号" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="客户密码">
                    <Input v-model="insertObject.userPassword" placeholder="输入客户密码" style="width: 250px" />
                </FormItem>

                <!-- <FormItem style="margin-top:-20px"  label="用户身份">
          <Select v-model="insertObject.userAuth" style="width:250px" placeholder="选择用户身份">
            <Option v-if="key != '0'" v-for="(value, key) in userAuthEnum" :value="key" :key="key">{{value}}</Option>
          </Select>
        </FormItem> -->
                <FormItem style="margin-top:-20px" label="设备类型">
                    <Select disabled v-model="insertObject.userMeterType" style="width:250px" placeholder="选择设备类型">
                        <!-- <Option v-for="(value, key) in userMeterTypeEnum" :value="key" :key="key">{{ value }}</Option> -->
                        <Option v-for="item in showOrder" :value="item" :key="item">{{ userMeterTypeEnum[item] }}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button style="margin-right:38%" type="primary" @click="insertUser">提交新增</Button>
            </div>
        </Modal>
        <Modal v-model="isShowSetModal" :mask-closable="false" width="700">
            <p slot="header" style="text-align:center">
                <Icon type="md-create" />
                <span>显示项设置</span>
            </p>
            <!-- <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
        </tr> -->
            <Form label-position="left" :label-width="100" style="margin-left:20px">
                <FormItem label="展示数据">
                    <Tag
                        :checked="showColumnTitleArray.indexOf(item.title) > -1"
                        v-for="item in columnsbackup"
                        :name="item.title"
                        @on-change="changeColumn"
                        size="medium"
                        checkable
                        color="primary"
                        >{{ item.title }}</Tag
                    >
                </FormItem>
            </Form>
            <div slot="footer">
                <!-- <Button type="primary" @click="true" style="margin-left: 20px;">确定</Button> -->
            </div>
        </Modal>
        <div style="background: #fff; border-radius: 8px; padding: 20px;">
            <div class="query-c">
                <div>
                    <!-- <Input v-model="userAccount" placeholder="输入客户账号" style="width: 200px;margin-right: 5px" /> -->
                    <Input v-model="userName" placeholder="输入客户名称" style="width: 10%;margin-right: 5px" />

                    <Button style="margin-left:10px" type="primary" icon="ios-search" @click="showPage">查询</Button>

                    <!-- <Button type="primary" @click="isInserteModal = true" style="margin-left: 20px;">分配账号</Button> -->
                    <Button type="primary" @click="isShowSetModal = true" style="margin-left: 20px;float:right">显示项设置</Button>

                    <Button type="primary" @click="isInserteModal = true" style="margin-left: 60px;">添加</Button>
                    <Button type="primary" @click="clickUpdate" style="margin-left: 10px;">修改</Button>
                    <Button type="primary" @click="clickDel" style="margin-left: 10px;">删除</Button>
                </div>
            </div>
            <br />
            <Table
                highlight-row
                @on-current-change="changeSelect"
                size="small"
                :height="tableHeight"
                border
                stripe
                :columns="columns"
                :data="data"
            >
                <template slot-scope="{ row, index }" slot="action">
                    <!-- <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="isShowStateModal = true;updateObject=row;updateObject.userAuth = String(updateObject.userAuth);updateObject.userMeterType = String(updateObject.userMeterType)"
          >修改</Button>
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="resetPassword(row)"
          >重置密码</Button> -->
                    <Button
                        type="primary"
                        size="small"
                        :disabled="row.userRemark1 == '' || row.userRemark1 == undefined"
                        style="margin-right: 5px"
                        @click="debindWx(row)"
                        >解绑小程序</Button
                    >
                </template>

                <template slot-scope="{ row, index }" slot="wxstate">
                    <span v-if="row.userRemark1 != undefined && row.userRemark1 != ''" style="color:#19be6b">已绑定</span>
                    <span v-if="row.userRemark1 == undefined || row.userRemark1 == ''" style="color:#ed4014">未绑定</span>
                </template>
            </Table>
            <br />
            <!-- <Page :total="100" show-sizer show-elevator /> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "distributeaccount",
    data() {
        return {
            pageName: "distributeaccount",
            updateObject: {},
            insertObject: {
                userPassword: "123456",
				userAuth: 1,
				userMeterType: "5"
            },
            showColumnTitleArray: [],
            isInserteModal: false,
            isShowStateModal: false,
            userAccount: "",
            userName: "",
            columnsbackup: [
                {
                    title: "序号",
                    type: 'index',
                    width: 100,
                    align: 'center'
                },
                {
                    title: "客户名称",
                    key: "userName",
                    width: 320,
                    resizable: true
                },
                {
                    title: "账号",
                    key: "userAccount",
                    resizable: true,
                    width: 160
                },
                {
                    title: "密码",
                    key: "userPassword",
                    width: 160,
                    resizable: true
                },
                // {
                //   title: '用户身份',
                //   width: 160,
                //   render: (h, params) => {
                //   return h("div", [
                //       h(
                //         "span", {
                //           props: {},
                //           style: {},
                //           on: {}
                //         },
                //         this.userAuthEnum[params.row.userAuth]
                //       )
                //     ]);
                //   }
                // },
                {
                    title: "设备类型",
                    width: 160,
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span",
                                {
                                    props: {},
                                    style: {},
                                    on: {}
                                },
                                this.userMeterTypeEnum[params.row.userMeterType]
                            )
                        ]);
                    }
                },
                {
                    title: "创建时间",
                    width: 180,
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span",
                                {
                                    props: {},
                                    style: {},
                                    on: {}
                                },
                                global.dateFtt("yyyy-MM-dd", new Date(params.row.userCreatetime))
                            )
                        ]);
                    }
                }
                // ,
                // {
                //   title: "小程序绑定状态",
                //   slot: "wxstate",
                //   width: 150,
                //   align: "center"
                // },
                // {
                //   title: "操作",
                //   slot: "action",
                //   width: 160,
                //   align: "center"
                // }
                // ,
                // {
                //   title: "设备状态",
                //   slot: "action",
                //   width: 150,
                //   align: "center"
                // }
            ],
            tableHeight: "200",
            addressfield1: "",
            addressfield2: "",
            addressfield3: "",
            addressfield4: "",
            addressfield5: "",
            // meterArray: ["00000018003155", "00000018004345", "00000018004361", "00000018004457", "00000018004523",
            //   "00000018004635", "00000018004782", "00000018004789", "00000018004798", "00000018004799", "00000018004850",
            //   "00000018005048", "00000018005051", "00000018005064", "00000018005332", "00000018005388", "00000018005401",
            //   "00000018005405", "00000018005456", "00000018005462"
            // ],
            meterArray: [],
            meterArray1: [
                "00000018003155",
                "00000018004361",
                "00000018004457",
                "00000018004523",
                "00000018004798",
                "00000018005064",
                "00000018005332",
                "00000018005401",
                "00000018005456",
                "00000018005462",
                "11110000000000"
            ],
            meterArray2: ["00000018005405", "00000018004345", "00000018004799"],
            addressObject: {},
            stateContrast: global.stateContrast,
            meterAddress: "",
            stateArray: {},
            userAuthEnum: {
                "0": "管理员",
                "1": "客户"
            },
            userMeterTypeEnum: {
                "0": "水表(流量计)",
                "5": "流量计",
                "1": "热量表",
                "2": "动态平衡阀",
                "3": "消防栓",
                "4": "压力开关、流量开关"
            },
            showOrder: ["0", "5", "1", "2", "3", "4"],
            isShowStateModal: false,
            isShowSetModal: false,
            selectedRow: {},
            columns: [
                {
                    title: "序号",
                    type: 'index',
                    width: 100,
                    align: 'center'
                },
                {
                    title: "客户名称",
                    key: "userName",
                    width: 320,
                    resizable: true
                },
                {
                    title: "账号",
                    key: "userAccount",
                    resizable: true,
                    width: 160
                },
                {
                    title: "密码",
                    key: "userPassword",
                    width: 160,
                    resizable: true
                },
                // {
                //   title: '用户身份',
                //   width: 160,
                //   render: (h, params) => {
                //   return h("div", [
                //       h(
                //         "span", {
                //           props: {},
                //           style: {},
                //           on: {}
                //         },
                //         this.userAuthEnum[params.row.userAuth]
                //       )
                //     ]);
                //   }
                // },
                {
                    title: "设备类型",
                    width: 160,
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span",
                                {
                                    props: {},
                                    style: {},
                                    on: {}
                                },
                                this.userMeterTypeEnum[params.row.userMeterType]
                            )
                        ]);
                    }
                },
                {
                    title: "创建时间",
                    width: 180,
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span",
                                {
                                    props: {},
                                    style: {},
                                    on: {}
                                },
                                global.dateFtt("yyyy-MM-dd", new Date(params.row.userCreatetime))
                            )
                        ]);
                    }
                }
                // ,
                // {
                //   title: "小程序绑定状态",
                //   slot: "wxstate",
                //   width: 150,
                //   align: "center"
                // },
                // {
                //   title: "操作",
                //   slot: "action",
                //   width: 160,
                //   align: "center"
                // }
            ],
            data: []
        };
    },
    methods: {
        clickUpdate() {
            if (this.selectedRow.userAccount == undefined) {
                this.$Modal.info({
                    title: "提示",
                    content: "先选中一行"
                });
                return;
            }

            this.isShowStateModal = true;
            this.updateObject = this.selectedRow;
            this.updateObject.userAuth = String(this.updateObject.userAuth);
            this.updateObject.userMeterType = String(this.selectedRow.userMeterType);
        },
        clickDel() {
            if (this.selectedRow.userAccount == undefined) {
                this.$Modal.info({
                    title: "提示",
                    content: "先选中一行"
                });
                return;
            }

            var that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "<p>若删除此客户账号，则此账号不能再登录其管理系统！</p>",
                onOk: () => {
                    that.$axios
                        .post("/api/user/delUser", that.selectedRow)
                        .then(data => {
                            if (data.errorCode != 0) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: data.errorInfo
                                });
                                return;
                            }

                            that.$Notice.success({
                                title: "提示",
                                desc: "删除成功"
                            });
                            return;
                        })
                        .catch(error => {
                            that.$Notice.error({
                                title: "异常",
                                desc: error
                            });
                            console.log(error);
                        })
                        .finally(() => {
                            that.showPage();
                            that.selectedRow = {};
                        });
                },
                onCancel: () => {}
            });
        },
        changeSelect(current, old) {
            this.selectedRow = current;
        },
        insertUser() {
            var that = this;
            if (
                that.insertObject.userAccount == "" ||
                that.insertObject.userAccount == undefined ||
                that.insertObject.userPassword == "" ||
                that.insertObject.userPassword == undefined ||
                that.insertObject.userAuth == "" ||
                that.insertObject.userAuth == undefined ||
                that.insertObject.userMeterType == "" ||
                that.insertObject.userMeterType == undefined
            ) {
                this.$Modal.info({
                    title: "提示",
                    content: "请填写正确的账户信息"
                });
                return;
            }

            that.isInsertStateModal = false;
            that.$axios
                .post("/api/user/insertUser", that.insertObject)
                .then(data => {
                    if (data.errorCode != 0) {
                        that.$Notice.error({
                            title: "异常",
                            desc: data.errorInfo
                        });
                        return;
                    }

                    that.$Notice.success({
                        title: "提示",
                        desc: "新增成功"
                    });
                    return;
                })
                .catch(error => {
                    that.$Notice.error({
                        title: "异常",
                        desc: error
                    });
                    console.log(error);
                })
                .finally(() => {
                    that.showPage();
                    that.isInserteModal = false;
                });
        },
        updateUser() {
            var that = this;
            if (
                that.updateObject.userAccount == "" ||
                that.updateObject.userAccount == undefined ||
                that.updateObject.userPassword == "" ||
                that.updateObject.userPassword == undefined ||
                that.updateObject.userAuth == "" ||
                that.updateObject.userAuth == undefined ||
                that.updateObject.userMeterType == "" ||
                that.updateObject.userMeterType == undefined
            ) {
                this.$Modal.info({
                    title: "提示",
                    content: "请填写正确的账户信息"
                });
                return;
            }

            that.isShowStateModal = false;
            that.$axios
                .post("/api/user/updateUser", that.updateObject)
                .then(data => {
                    if (data.errorCode != 0) {
                        that.$Notice.error({
                            title: "异常",
                            desc: data.errorInfo
                        });
                        return;
                    }

                    that.$Notice.success({
                        title: "提示",
                        desc: "修改成功"
                    });
                    return;
                })
                .catch(error => {
                    that.$Notice.error({
                        title: "异常",
                        desc: error
                    });
                    console.log(error);
                })
                .finally(() => {
                    that.showPage();
                    that.selectedRow = {};
                    that.isShowStateModal = false;
                });
        },
        debindWx(row) {
            var that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "<p>是否要解除小程序绑定？</p>",
                onOk: () => {
                    that.updateObject = row;
                    that.updateObject.userRemark1 = "";
                    that.updateUser();
                },
                onCancel: () => {}
            });
        },
        resetPassword(row) {
            var that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "<p>是否要重置密码为123456？</p>",
                onOk: () => {
                    that.updateObject = row;
                    that.updateObject.userPassword = "123456";
                    that.updateUser();
                },
                onCancel: () => {}
            });
        },
        generateColumnTitleArray() {
            let titleArray = [];

            for (let i = 0; i < this.columnsbackup.length; i++) {
                titleArray.push(this.columnsbackup[i].title);
            }

            this.showColumnTitleArray = titleArray;
            if (localStorage.getItem(this.pageName + localStorage.getItem("userAccount")) != undefined) {
                this.showColumnTitleArray = JSON.parse(localStorage.getItem(this.pageName + localStorage.getItem("userAccount")));
                var showArray = [];
                for (let i = 0; i < this.columnsbackup.length; i++) {
                    let currentObject = this.columnsbackup[i];
                    if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
                        showArray.push(currentObject);
                    }
                }

                this.columns = showArray;
            }
        },
        getAddressEnum() {
            var that = this;
            that.$axios
                .post("/api/dictionary/selectAddressEnum", {})
                .then(data => {
                    if (data.errorCode != 0) {
                        that.$Notice.error({
                            title: "异常",
                            desc: data.errorInfo
                        });
                        return;
                    }

                    that.addressObject = data.body;
                })
                .catch(error => {
                    that.$Notice.error({
                        title: "异常",
                        desc: error
                    });
                    console.log(error);
                })
                .finally(() => {});
        },
        parseDate(str) {
            var year = str.substr(0, 4);
            var month = str.substr(4, 2);
            var day = str.substr(6, 2);
            var hour = str.substr(8, 2);
            var minute = str.substr(10, 2);
            var second = str.substr(12, 2);
            return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
        },
        onClickSearch() {
            this.showPage();
        },
        showState(row) {
            this.isShowStateModal = true;
            this.stateArray = JSON.parse(row.messageContent).decode.state;
        },
        showStateStr(row) {
            let stateArray = JSON.parse(row.messageContent).decode.state;
            let that = this;
            let stateStr = "";
            Object.keys(stateArray).forEach(function(key) {
                if (stateArray[key] == that.stateContrast[key]) {
                    stateStr = stateStr + key + " " + that.stateContrast[key] + "; ";
                }
            });

            return stateStr == "" ? "正常" : stateStr.replace("空管 空管", "空管");
        },
        changeColumn(checked, name) {
            if (checked) {
                this.showColumnTitleArray.push(name);
            } else {
                this.showColumnTitleArray.splice(this.showColumnTitleArray.indexOf(name), 1);
            }

            var showArray = [];

            for (let i = 0; i < this.columnsbackup.length; i++) {
                let currentObject = this.columnsbackup[i];
                if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
                    showArray.push(currentObject);
                }
            }
            localStorage.setItem(this.pageName + localStorage.getItem("userAccount"), JSON.stringify(this.showColumnTitleArray));

            this.columns = showArray;
        },
        showPage() {
            var that = this;
            //that.data = [];
            that.$axios
                .post("/api/user/getUserList", {
                    userAccount: that.userAccount,
					userName: that.userName,
					userMeterType: 5
                })
                .then(function(res) {
                    console.log(res);

                    let userArray = res.body;
                    let resultArray = [];

                    for (let i = 0; i < userArray.length; i++) {
                        if (userArray[i].userAuth == "1") {
                            resultArray.push(userArray[i]);
                        }
                    }

                    that.data = resultArray;
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    },
    mounted() {
        // this.showPage();
        let that = this;
        window.addEventListener("resize", function() {
            that.tableHeight = (window.innerHeight - 186) * 0.8;
        });
        that.tableHeight = (window.innerHeight - 186) * 0.8;

        that.generateColumnTitleArray();
        that.showPage();
    }
};
</script>

<style scoped></style>
